export var selectUser = function selectUser(state) {
  return state.user;
};
export var selectApperData = function selectApperData(state) {
  return selectUser(state).apperData;
};
export var selectUserApper = function selectUserApper(state) {
  return selectUser(state).currentApper;
};
export var selectAppersList = function selectAppersList(state) {
  return selectUser(state).apperList;
};